module.exports = __webpack_public_path__ + "img/LC.179e622a.png";